import moment from 'moment-timezone';

export const getLocalTimeZone = () => moment.tz.guess();

export const getLocale = () => window.navigator.language || window.navigator.userLanguage;